module.exports = __webpack_public_path__ + "static/img/aepic-5.7b55d0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-5.jpg
// module id = iy1G
// module chunks = 52